import { ITypeBundle } from '../../../models/TypeBundle';
import { useCatalogTypesBaseHook } from '../useCatalogBaseHook';
import { IHookProvidedDataSource } from '../../../../hooks/useNetworkCallForDataSource/IHookProvidedDataSource';

export const useGetCatalogTypes = (): IHookProvidedDataSource<ITypeBundle[]> => useCatalogTypesBaseHook();
